import { render, staticRenderFns } from "./AssignedPetitionsList.vue?vue&type=template&id=e3e00a20"
import script from "./AssignedPetitionsList.vue?vue&type=script&lang=js"
export * from "./AssignedPetitionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports